import React, {useMemo, useState} from 'react';
import cl from "./FormLinkedItemListView.module.css";
import {Chip} from "@mui/material";
import FormControlCaption from "./FormControlCaption";

const FormLinkedItemListView = ({
                                      label,
                                      options,
                                      selectedItemsAreaWidthLimit,
                                      selectedItemsAreaType = "normal", // nornal|column
                                      showIds,
                                      tipText,
                                  }) => {

    // NOTE: вместо options далее будем пользоваться modOptions,
    //   где автоматически создаются (при необходимости) опции, нужные для показа исходной выборки
    const modOptions = useMemo(() => {
        const result = [...options];
        return result;
    }, [options])

    // NOTE: исходную выборку сортируем по алфавиту. однако, при добавлении, новые элементы всегда будут вставляться в конец списка
    const [selectedOptions, setSelectedOptions] = useState(() => {
        const result = modOptions;
        return result.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
    });

    const correctedSelectedItemsAreaWidthLimit = selectedItemsAreaWidthLimit === undefined ? 10000 : selectedItemsAreaWidthLimit;

    function getFilteredOptions(options, searchText) {
        const trimmedSearchText = searchText.trim();

        if (trimmedSearchText === "")
            return options.slice(0, 100);

        if (trimmedSearchText.length >= 3 && /^id\d{1,6}$/.test(trimmedSearchText)) {
            const searchId = parseInt(trimmedSearchText.slice(2));
            return options.filter(x => x.id === searchId);
        }

        const searchParts = trimmedSearchText.toLocaleLowerCase().split(" ").filter(x => x !== "")

        return options.filter(x => testSearchMatch(x.name.toLowerCase(), searchParts)).slice(0, 100);
    }


    function testSearchMatch(str, searchParts) {

        const strParts = str.split(" ").filter(x => x !== "");

        for (const searchPart of searchParts) {
            let partFound = false;

            for (const strPart of strParts) {
                if (strPart.includes(searchPart)) {
                    partFound = true;
                    break;
                }
            }

            if (!partFound)
                return false;
        }

        return true;
    }

    function renderSelectedItem(item, index) {
        return <Chip
            key={item.id}
            label={<div style={{display: "flex", gap: "5px", alignItems: "center"}}>
                <span style={{whiteSpace: "wrap"}}>{item.name}</span>
                {showIds && renderIdInfo(item.id)}
            </div>}
            variant="outlined"
            sx={{
                backgroundColor: "#d0d0d0",
                fontSize: "16px",
                height: "min-content",
                minHeight: "32px",
                paddingTop: "4px",
                paddingBottom: "4px"
            }}
        />
    }


    return (
        <div className={cl.main}>
            <FormControlCaption
                text={label}
                tipText={tipText}
            />
            <div
                className={selectedItemsAreaType === "column" ? cl.selectedItemsArea_column : cl.selectedItemsArea_normal}
                style={{maxWidth: `min(${correctedSelectedItemsAreaWidthLimit}px, 100%)`}}>
                {selectedOptions.length > 0 ?
                    selectedOptions.map((item, index) => renderSelectedItem(item, index)) :
                    <span className={cl.emptyListLabel}>(список пуст)</span>}
            </div>
        </div>
    );
};

function renderIdInfo(id) {
    return <span className={cl.idInfo}>ID {id}</span>
}

export default FormLinkedItemListView;